import React, { useEffect, useState } from "react";
import { GET_AUDIT_BY_MOBILE_NO, GET_TIMELINE } from "../../constants";
import axios from "axios";
import {
  Card,
  CardContent,
  Chip,
  Typography,
  Divider,
  Box,
} from "@mui/material";
import moment from "moment";
import StarIcon from "@mui/icons-material/Star";
import { styled } from "@mui/system"; // Import the styled API from @mui/system

// Styled components using @mui/system
const StyledCard = styled(Card)({
  marginBottom: "20px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  borderRadius: "12px",
});

const CardHeader = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "10px",
});

const StatusChip = styled(Chip)(({ theme, actionType }) => ({
  fontWeight: "bold",
  padding: "8px 12px",
  borderRadius: "16px",
  background: getColorForActionType(actionType),
  color: "#fff",
  textTransform: "capitalize",
  marginBottom: "5px",
}));

const DateText = styled("div")({
  fontSize: "14px",
  fontWeight: 600,
  color: "#444",
});

const Title = styled(Typography)({
  marginBottom: "10px",
  fontSize: "16px",
  fontWeight: "500",
});

const Content = styled("div")({
  whiteSpace: "normal",
  wordWrap: "break-word",
  overflowWrap: "break-word",
});

const getColorForActionType = (actionType) => {
  switch (actionType) {
    case "Lead Created by Agent":
      return "linear-gradient(to right, #42e695, #3bb2b8)"; // Green-Teal Gradient
    case "Lead Created by bulk upload":
      return "linear-gradient(to right, #ff7e5f, #feb47b)"; // Peach-Orange Gradient
    case "Lead Created by BDM":
      return "linear-gradient(to right, #ff7e5f, #feb47b)"; // Peach-Orange Gradient
    case "Follow-up by Agent":
      return "linear-gradient(to right, #6a11cb, #2575fc)"; // Purple-Blue Gradient
    case "On Call Discussion By BDM":
      return "linear-gradient(to right, #ff9966, #ff5e62)"; // Orange-Red Gradient
    case "Meeting Completed":
      return "linear-gradient(to right, #f857a6, #ff5858)"; // Pink-Red Gradient
    case "Site Visit Completed":
      return "linear-gradient(to right, #43cea2, #185a9d)"; // Teal-Navy Blue Gradient
    case "Estimation Requested":
      return "linear-gradient(to right, #00c6ff, #0072ff)"; // Light Blue-Dark Blue Gradient
    case "Estimation Need for Approval":
      return "linear-gradient(to right, #f7971e, #ffd200)"; // Orange-Yellow Gradient
    case "Estimation Generated":
      return "linear-gradient(to right, #4facfe, #00f2fe)"; // Sky Blue Gradient
    case "Estimation Shared":
      return "linear-gradient(to right, #36d1dc, #5b86e5)"; // Cyan-Indigo Gradient
    case "Estimation Rejected":
      return "linear-gradient(to right, #36d1dc, #5b86e5)"; // Cyan-Indigo Gradient
    case "Lead Converted":
      return "linear-gradient(to right, #56ab2f, #a8e063)"; // Green Gradient
    case "Lead Edited By Manual":
      return "linear-gradient(to right, #f39c12, #d35400)";
    case "Lead Edited By Call":
      return "linear-gradient(to right, #f39c12, #d35400)";
    default:
      return "linear-gradient(to right, #bdc3c7, #2c3e50)"; // Default Grey Gradient
  }
};

function ExistingTimelineComponent({ FormMobileNo, leadDetailId }) {
  const [timelineData, setTimelineData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchTimelineData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${GET_TIMELINE}/${leadDetailId}`);
      const { success, leadLogs } = response.data;

      console.log(leadLogs);

      setTimelineData(leadLogs);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (leadDetailId !== "") {
      fetchTimelineData();
    } else {
      setTimelineData([]);
    }
  }, [leadDetailId]);

  const formatDate = (date) => {
    return moment(date).format("MMMM D, YYYY, h:mm A");
  };

  // console.log(timelineData[0].remarks_summary, "-------------");

  return (
    <>
      {loading ? (
        <div>Loading...</div>
      ) : timelineData.length > 0 ? (
        <div
      style={{
        maxHeight: "calc(100vh - 50px)", // Adjust the height based on your layout
        overflowY: timelineData.length > 4 ? "auto" : "visible", // Show scroll if there are more than 4 cards
      }}
    >
        {timelineData.map((log, index) => (
          <StyledCard key={index}>
            <CardContent>
              <CardHeader>
                <DateText>
                  <strong>Last Action Date: &nbsp;</strong>
                  {log.updatedAt ? formatDate(log.updatedAt) : "-"}
                </DateText>
                <StarIcon
                  sx={{
                    backgroundColor: "rgb(16, 204, 82)",
                    color: "#fff",
                    borderRadius: "50%",
                    padding: "5px",
                  }}
                />
              </CardHeader>

              {/* Action type and category */}
              <StatusChip
                label={`${log.action_type}`}
                actionType={log.action_type}
              />

              {/* Farmer and Lead Details */}
              {/* <Title variant="h5">
                <strong>Lead ID:&nbsp;</strong>
                <strong>{log.LeadDetailId}</strong>
              </Title> */}
              <Divider />

              {log.action_type === "Lead Edited By Manual" ||
              log.action_type === "Lead Edited By Call" ? (
                // Special rendering for "Pending Lead Update"
                <div>
                  <h4 className="vertical-timeline-element-subtitle">
                    Changes made by <strong>{log.PerformedBy?.EmployeeName}</strong>
                  </h4>
                  <ul style={{ paddingLeft: "20px", marginTop: "2px" }}>
                    {log.extra_fields3?.formattedChanges.map(
                      (change, idx) => (
                        <li
                          key={idx}
                          style={{ marginBottom: "8px", listStyle: "disc" }}
                        >
                          <strong>{change.field}:</strong>{" "}
                          {change.from ? (
                            <>
                              Changed from <em>{change.from || "-"}</em> to{" "}
                              <em>{change.to || "-"}</em>
                            </>
                          ) : (
                            <>
                              Added <em>{change.to || "-"}</em>
                            </>
                          )}
                        </li>
                      )
                    )}
                  </ul>
                  {/* <p>
                                <strong>Remarks:</strong>{" "}
                                {log.formattedChanges?.changes.find(
                                  (change) => change.field === "Remarks"
                                )?.to || "No remarks provided."}
                              </p> */}
                </div>
              ) : (
                <>
                  <Content>
                    <strong>Category:</strong> {log.category || "-"}
                    <br />
                    <strong>Sub Category:</strong> {log.sub_category || "-"}
                    <br />
                    <strong>Performed By:</strong>{" "}
                    {log.PerformedBy?.EmployeeName || "N/A"}
                  </Content>

                  {/* Displaying remarks */}
                  <div>
                    <strong>Remarks:</strong>
                    {log.remarks ? (
                      <p>{log.remarks}</p>
                    ) : (
                      <p>No Remarks available.</p>
                    )}
                  </div>

                  {/* Follow-up date */}
                  <div>
                    <strong>Follow-up Date:</strong> &nbsp;
                    {log.follow_up_date
                      ? formatDate(log.follow_up_date)
                      : "N/A"}
                  </div>
                </>
              )}
            </CardContent>
          </StyledCard>
        ))}
        </div>
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="100%"
          padding={2}
          sx={{
            border: "1px dashed #ccc",
            borderRadius: "8px",
            backgroundColor: "#f9f9f9",
            color: "#666",
            textAlign: "center",
          }}
        >
          <Typography variant="h6" sx={{ marginBottom: 1, color: "#444" }}>
            No Existing Records
          </Typography>
          <Typography variant="body2">
            We couldn't find any records to display at the moment.
          </Typography>
          <Box mt={2}>
            {/* <img
              src="https://via.placeholder.com/150"
              alt="No Records"
              style={{ width: "100px", height: "100px", opacity: 0.7 }}
            /> */}
          </Box>
        </Box>
      )}
    </>
  );
}

export default ExistingTimelineComponent;
